/**
 * @fileoverview Utilities for checking agent membership in livechat sessions.
 */

import store from "@/store";
import _ from "lodash";

/**
 * Checks if a chat session belongs to the specified agent.
 * Verifies agent is in the chat's agent list and chat is not removed/resolved.
 *
 * @param {string} agentEmail - Agent email address
 * @param {string} user_id - Chat session user ID
 * @returns {boolean} True if chat belongs to agent and is active
 *
 * @example
 * if (doesChatBelongsToCurrentAgent('agent@example.com', 'user123')) {
 *   console.log('Agent is in this chat');
 * }
 */
export function doesChatBelongsToCurrentAgent(agentEmail: string, user_id: string): boolean {
  const queueChatsObject = store.state.livechat.queueChatObject;
  const queueChats = Object.values(queueChatsObject);
  const selectedChat = _.find(queueChats, { user_id });
  const agents = _.get(selectedChat, "agents", ["does not exist"]);
  const isRemoved = _.get(selectedChat, "isRemoved"); // when chat resolved, it will be remain with status isRemoved = true

  const belongsToCurrentAgent = agents.includes(agentEmail);
  return belongsToCurrentAgent && !isRemoved;
}
